import React, { useEffect, useState } from 'react'
import CustomColumn from '../../customControl/CustomColumn';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../commonClass/Session';
import TagInputField from '../../customControl/TagInputField';
import secureLocalStorage from 'react-secure-storage';

const SEOConfiguration = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [keywords, setKeywords] = useState([]);

    const [disabled, setDisabled] = useState(false);
    const [editDisabled, setEditDisabled] = useState(false);

    const [keywordInput, setKeywordInput] = useState("");
    const [formValue, setFormValue] = useState({
        SEOConfigurationId: 0,
        TravelCategoryId: 0,
        PackageId: 0,
        Title: "",
        Description: "",
        Keywords: [],
        URL: "",
        UserId: 0
    })
    const [formErrors, setFormErrors] = useState(null);

    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        setFormValue((prev) => ({ ...prev, [name]: value }));
    }

    const getseopanelbyId = async (seoconfigId) => {
        const seopanelbyId = await getAllData(`/master/v1/getseopanelbyId?seoconfigId=${seoconfigId}`);
        if (seopanelbyId?.status) {
            const resData = seopanelbyId?.data?.[0];
            setFormValue((prev) => ({
                ...prev,
                SEOConfigurationId: seoconfigId,
                Title: resData?.title || "",
                Description: resData?.description || "",
                URL: resData?.url || "",
            }))
            setKeywords(resData?.keywords || [])
        }
    }


    useEffect(() => {
        function fetchData() {
            setDisabled(location?.state?.disabled || false);
            setEditDisabled(location?.state?.editdisabled || false)

            const productId = location?.state?.productId || 0;
            const seoConfigurationId = secureLocalStorage.getItem("seoconfigid") || location?.state?.item?.seoConfigurationId || 0;
            const packageId = location?.state?.item?.packageId || 0;
            setFormValue((prev) => ({
                ...prev,
                TravelCategoryId: productId,
                SEOConfigurationId: seoConfigurationId,
                PackageId: packageId,
            }))
            getseopanelbyId(seoConfigurationId)
        }

        if (location?.state === null) {
            return navigate("/SEOPanelList")
        }
        fetchData();

    }, [location])

    const addKeywordValidation = () => {
        let status = true;
        let error = {};

        if (keywords?.includes(keywordInput)) {
            error.Keywords = "Cannot enter duplicate keyword.";
        }

        setFormErrors(error);
        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }

        return status;
    }


    const handleBack = () => {
        navigate("/SEOPanelList")
    }

    const validate = () => {
        let status = true;
        let error = {};

        if (keywords?.length > 0 && keywords?.length < 5) {
            error.Keywords = "Please provide atleast 5 keywords.";
        }
        else if (keywords?.length > 10) {
            error.Keywords = "Max keywords limit of 10 is reached.";
        }

        setFormErrors(error);
        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }

        return status;
    }

    const handleSave = async () => {
        if (validate()) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                const payload = { ...formValue, Keywords: keywords, UserId: user?.userMasterID }

                const insertupdateseopanel = await postUsersData('/master/v1/insertupdateseopanel', payload);
                if (insertupdateseopanel?.status) {
                    dispatch({ type: 'ALERTING', message: insertupdateseopanel?.message });
                    secureLocalStorage.setItem("seoconfigid", insertupdateseopanel?.data);
                    getseopanelbyId(insertupdateseopanel?.data);
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertupdateseopanel?.message });
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
    }

    const handleClear = () => {
        setEditDisabled(false);
        setFormErrors(null);

        setKeywordInput("");
        setFormValue((prev) => ({
            ...prev,
            Title: "",
            Description: "",
            URL: "",

        }))
        setKeywords([]);
    }

    const enableEditingAndResetErrors = () => {
        setEditDisabled(false);
        setFormErrors(null);
    }

    return (
        <div className="container-fluid form_border my-3">
            <div className="container-fluid mt-4 heading_color">
                <h3>SEO Configuration</h3>
            </div>
            <div className="row justify-content-center">
                <div className="col-xl-11 col-12">
                    <div className="row gx-5">
                        <div className="col-md-6 col-12 my-3">
                            <div className="container-fluid form_border py-5 h-100">
                                <div className="row justify-content-center">
                                    <CustomColumn colXLNum={10} colNum={12} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} classlabel={"fw-bold"} labelText='Meta Title' labelId='Title' >
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="Title"
                                            id="Title"
                                            disabled={disabled}
                                            placeholder='Meta Title'
                                            value={formValue?.Title}
                                            onChange={(e) =>
                                                e?.target?.value?.length <= 60 &&
                                                handleOnChange(e.target.name, e?.target?.value)
                                            }
                                            maxLength={60}
                                        />
                                        {formErrors?.Title && <div className="text-danger text-start fs_14">{formErrors?.Title}</div>}
                                    </CustomColumn>

                                    <CustomColumn colXLNum={10} colNum={12} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} classlabel={"fw-bold"} labelText='Meta Description' labelId='Description' >
                                        <textarea
                                            type="text"
                                            rows={3}
                                            style={{ resize: 'none' }}
                                            className='form-control'
                                            name="Description"
                                            id="Description"
                                            disabled={disabled}
                                            placeholder='Meta Description'
                                            value={formValue?.Description}
                                            onChange={(e) =>
                                                e?.target?.value?.length <= 160 &&
                                                handleOnChange(e.target.name, e?.target?.value)
                                            }
                                            maxLength={160}
                                        />
                                        {formErrors?.Description && <div className="text-danger text-start fs_14">{formErrors?.Description}</div>}
                                    </CustomColumn>

                                    <CustomColumn colXLNum={10} colNum={12} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} classlabel={"fw-bold"} labelText='Meta keywords' labelId='Keywords' >
                                        <TagInputField
                                            value={keywords}
                                            onChange={setKeywords}
                                            placeholder="Meta keywords"
                                            handleEnableEdit={enableEditingAndResetErrors}
                                            input={keywordInput}
                                            inputMaxLength={120}
                                            setInput={setKeywordInput}
                                            addTagValidation={addKeywordValidation}
                                            disabled={disabled}
                                        />

                                        {/* <div className="tag-container form-control">

                                            {formValue?.Keywords?.map((tag, index) => (
                                                <div className="tag" key={`tag${index}`}>
                                                    {tag}
                                                    <button onClick={() => removeTag(tag)}> &times; </button>
                                                </div>
                                            ))}

                                            <input
                                                type="text"
                                                className=''
                                                name="keywordInput"
                                                id="Keywords"
                                                disabled={disabled}
                                                placeholder={` ${formValue?.Keywords?.length > 0 ? "" : "Meta keywords"}`}
                                                value={keywordInput}
                                                onKeyDown={handleKeyDown}
                                                onChange={(e) => {
                                                    setEditDisabled(false);
                                                    setFormErrors(null);

                                                    e?.target?.value?.length <= 120 &&
                                                        setKeywordInput(e?.target?.value)
                                                }
                                                }
                                                maxLength={120}
                                            />
                                        </div> */}
                                        {formErrors?.Keywords && <div className="text-danger text-start fs_14">{formErrors?.Keywords}</div>}
                                    </CustomColumn>

                                    <CustomColumn colXLNum={10} colNum={12} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} classlabel={"fw-bold"} labelText='SEO Friendly URL' labelId='URL' >
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="URL"
                                            id="URL"
                                            disabled={disabled}
                                            placeholder='SEO Friendly URL'
                                            value={formValue?.URL}
                                            onChange={(e) => handleOnChange(e.target.name, e?.target?.value)}
                                        />
                                        {formErrors?.URL && <div className="text-danger text-start fs_14">{formErrors?.URL}</div>}
                                    </CustomColumn>
                                </div>

                                <div className="text-center mt-2">
                                    <button type="button" className='btn btn-primary mx-1' onClick={() => handleBack()} >
                                        Back
                                    </button>
                                    <button type="button" className='btn btn-primary mx-1' disabled={editDisabled} onClick={() => handleSave()} >
                                        Save
                                    </button>
                                    <button type="button" className='btn btn-primary mx-1' disabled={disabled} onClick={() => handleClear()} >
                                        Clear
                                    </button>
                                </div>

                            </div>
                        </div >
                        <div className="col-md-6 col-12 my-3">
                            <div className="container-fluid form_border py-5 h-100">
                                <div className='row'>
                                    <div className="col-md-12 col-12">
                                        <h5 className='fw-bold'> SERP Preview & Score </h5>
                                        {
                                            (formValue?.Title || formValue?.URL || formValue?.Description) &&
                                            <div className="seo_preview">
                                                <div className="seo_meta_title mb-1"> {formValue?.Title} </div>
                                                <div className="seo_meta_url mb-1"> {formValue?.URL} </div>
                                                <div className="seo_meta_description">
                                                    {/* for display long dash (—) :  Press and hold Alt, then type 0151 on the numeric keypad */}
                                                    {formValue?.Description}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default SEOConfiguration